export default "/assets/webpack-assets/GT-Walsheim-Pro-Regular.9ac6f750d95ac3dae781ae58233f46d6.ttf";